import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import IndexPage from '../components/IndexPage';
import About from '../components/About';
import Clients from '../components/Clients';
import FeatureCards from '../components/FeatureCards';
import Testimonials from '../components/Testimonials';
import Faq from '../components/Faq';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

import mcglogo from '../assets/img/mycareergems logo final.png';
import Swal from 'sweetalert2'; // Import SweetAlert2 for notifications

const Home = () => {
    const [showModal, setShowModal] = useState(true);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contact: '',
        query: ''
    });

    console.log(formData);
    

    const [status, setStatus] = useState({ loading: false, success: false, error: false });

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: false });

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbyu_Nx5XyCsB6ktspBVLV9FIBfTW5WB32aqFQxQxzH5a_j73AoLp2AQ0jXy0_CMVV7k/exec",
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: `Name=${formData.name}&Email=${formData.email}&Contact=${formData.contact}&Query=${formData.query}`,
        }
      ).then((res) => res.text())
        .then((data) => {
          let timerInterval;
          Swal.fire({
            title: `Message Sent Successfully!`,
            icon: 'success',
            html: "Autoclose in <b></b> milliseconds.",
            timer: 3000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const timer = Swal.getPopup().querySelector("b");
              timerInterval = setInterval(() => {
                timer.textContent = `${Swal.getTimerLeft()}`;
              }, 100);
            },
            willClose: () => {
              clearInterval(timerInterval);
            }

          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              console.log("");
            }
          });
          setStatus({ loading: false, success: true, error: false });
          setFormData({ name: "", email: "", subject: "", message: "" });
        })
        .catch((error) => {
          console.error("Error:", error);
          Swal.fire({
            icon: "error",
            title: "Oops!",
            text: "Something went wrong. Please try again later.",
            footer: '<a href="mailto:support@example.com">Need help? Contact support</a>',
          });
          setStatus({ loading: false, success: false, error: true });
        });
    } catch (error) {
      console.error("Submission error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Something went wrong. Please try again later.",
        footer: '<a href="mailto:support@example.com">Need help? Contact support</a>',
      });
      setStatus({ loading: false, success: false, error: true });
    }
  };

    return (
        <>
            <div>
                <IndexPage />
                <About />
                <Clients />
                <FeatureCards />
                <Testimonials />
                <Faq />
                <Contact />
                <Footer />
            </div>

            {/** Modal for Enquiry */}
            {showModal && (
                <div
                    className="modal fade show"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Enquiry Form</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={handleClose}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="text-center mb-3">
                                    <img
                                        src={mcglogo}
                                        alt="Enquiry"
                                        width={150}
                                        height={150}
                                    />
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            name="name"
                                            placeholder="Enter your name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            name="email"
                                            placeholder="Enter your email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="contact" className="form-label">Contact Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="contact"
                                            name="contact"
                                            placeholder="Enter your contact number"
                                            value={formData.contact}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="query" className="form-label">Your Query</label>
                                        <textarea
                                            className="form-control"
                                            id="query"
                                            name="query"
                                            rows="3"
                                            placeholder="Enter your query"
                                            value={formData.query}
                                            onChange={handleInputChange}
                                            required
                                        ></textarea>
                                    </div>

                                    {status.loading && <div className="loading">Submitting...</div>}
                                    {status.error && <div className="error-message">Something went wrong. Please try again.</div>}
                                    {status.success && <div className="sent-message">Your enquiry has been submitted. Thank you!</div>}

                                    <div className="modal-footer">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={status.loading}
                                        >
                                            {status.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Submit'}
                                        </button>
                                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                            Close
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Home;
